import { enable_tracing_mode_flag } from './index.js';

enable_tracing_mode_flag();
